import { FC } from 'react';

import Timeline from 'antd/es/timeline';
import Collapse from 'antd/es/collapse';

import { ArrowLeftSLine, ArrowUpSLine } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Markdown from '@components/utils/Markdown';
import { Row } from '@components/formStyles';

import {
  CollapseStyle,
  DotStyle,
  TimeLineStyle,
  DayNo,
  DayName,
} from './styled';
import { TextButton } from '../tour-selection/styled';

const { Panel } = Collapse;

const TourTimeline: FC<{
  data: { dayNo: number; name?: string; description?: string }[];
}> = ({ data = [] }) => {
  const timelineItems = data.map(({ dayNo, name, description }) => ({
    dot: <DotStyle>{dayNo}</DotStyle>,
    key: dayNo,
    children: (
      <CollapseStyle
        expandIcon={(panelProps) => (
          <Row style={{ marginTop: '24px' }}>
            <TextButton>
              Detayları {panelProps.isActive ? 'Gizle' : 'Göster'}
              <CustomIcon
                fontSize={18}
                icon={panelProps.isActive ? ArrowUpSLine : ArrowLeftSLine}
                paletteColor='grey800'
              />
            </TextButton>
          </Row>
        )}
        expandIconPosition='end'
      >
        <Panel
          header={
            <div>
              <DayNo>{dayNo + '. Gün'}</DayNo>
              <DayName>{name}</DayName>
            </div>
          }
          key='1'
        >
          {description ? <Markdown text={description} /> : null}
        </Panel>
      </CollapseStyle>
    ),
  }));

  return (
    <TimeLineStyle>
      <Timeline
        mode='left'
        style={{ flex: 1, marginLeft: '6px' }}
        items={timelineItems}
      />
    </TimeLineStyle>
  );
};

export default TourTimeline;
